/* Barrierefreiheits-Nachrüstung für die Kaching-App (Cart + Bundles/Upsells).
   Kaching rendert seine Widgets ohne Screenreader-Namen und mit englischen
   Labels — dieses Script ergänzt die fehlende Semantik nachträglich im DOM.
   Rein additiv: setzt nur ARIA-Attribute, ändert kein Verhalten und keine
   Optik. Wenn Kaching sein Markup ändert, greifen die Selektoren einfach
   nicht mehr (kein Fehler, nur kein Effekt). */
(function () {
  'use strict';

  function txt(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  /* --- 1. Upsell-Häkchen unter dem Kaufbutton ---------------------------
     Kaching baut sie als <span role="button" tabindex="0"> OHNE Namen und
     OHNE Zustand. Ein Screenreader sagt nur "Schalter" — die Kundin weiß
     weder was angehakt ist noch dass dadurch Zusatzprodukte im Warenkorb
     landen. Hier: echte Checkbox-Semantik + Name aus dem Produkttitel. */
  function upsellName(upsell) {
    var link = upsell.querySelector('.kaching-bundles__upsell__link');
    var name = txt(link) || txt(upsell);
    // Preis am Ende abschneiden ("Lehrbuch … €50,00" -> "Lehrbuch …")
    return name.replace(/€\s?[\d.,]+\s*$/, '').trim();
  }

  function enhanceUpsells() {
    var upsells = document.querySelectorAll('.kaching-bundles__upsell');
    for (var i = 0; i < upsells.length; i++) {
      var u = upsells[i];
      var cb = u.querySelector('[class*="__upsell__checkbox"]');
      if (!cb) continue;
      var name = upsellName(u);
      var checked = cb.className.indexOf('--selected') > -1 ? 'true' : 'false';
      if (cb.getAttribute('role') !== 'checkbox') cb.setAttribute('role', 'checkbox');
      if (cb.getAttribute('aria-checked') !== checked) cb.setAttribute('aria-checked', checked);
      if (name) {
        var label = name + ' zusätzlich mitbestellen';
        if (cb.getAttribute('aria-label') !== label) cb.setAttribute('aria-label', label);
      }
      // Der nackte Produktbild-Link daneben hat ebenfalls keinen Namen
      var link = u.querySelector('.kaching-bundles__upsell__link');
      if (link && !txt(link) && name && link.getAttribute('aria-label') !== name) {
        link.setAttribute('aria-label', name + ' – Produktseite öffnen');
      }
    }
  }

  /* --- 2. Englische ARIA-Labels im Cart-Drawer eindeutschen -------------
     Der Drawer selbst ist ordentlich (role=dialog, Fokus, ESC), aber die
     Bedien-Labels kommen englisch an ("Close cart", "Decrease quantity").
     Deutsche Shop-Sprache, deutscher Screenreader -> deutsche Labels. */
  var UEBERSETZUNGEN = [
    [/^Close cart$/i, 'Warenkorb schließen'],
    [/^Decrease quantity$/i, 'Menge verringern'],
    [/^Increase quantity$/i, 'Menge erhöhen'],
    [/^Quantity$/i, 'Menge'],
    [/^Proceed to Checkout$/i, 'Zur Kasse gehen'],
    [/^Remove (.+) from cart$/i, '$1 aus dem Warenkorb entfernen'],
    [/^Cart$/i, 'Warenkorb']
  ];

  function germanizeLabels() {
    var scope = document.querySelectorAll('.kaching-cart [aria-label], kaching-cart-drawer [aria-label], .kaching-bundles [aria-label]');
    for (var i = 0; i < scope.length; i++) {
      var el = scope[i];
      var val = el.getAttribute('aria-label');
      if (!val) continue;
      for (var j = 0; j < UEBERSETZUNGEN.length; j++) {
        if (UEBERSETZUNGEN[j][0].test(val)) {
          var neu = val.replace(UEBERSETZUNGEN[j][0], UEBERSETZUNGEN[j][1]);
          if (neu !== val) el.setAttribute('aria-label', neu);
          break;
        }
      }
    }
  }

  /* --- Ausführung: initial + bei DOM-Änderungen (Kaching rendert spät
     und bei jeder Cart-Änderung neu). Debounced, damit der Observer bei
     Render-Bursts nicht pro Mutation feuert. */
  var pending = null;
  function run() {
    pending = null;
    try {
      enhanceUpsells();
      germanizeLabels();
    } catch (e) { /* nie den Shop stören */ }
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(run, 150);
  }

  function start() {
    run();
    var mo = new MutationObserver(schedule);
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
